<template>
  <introduce-page>
    <div style="margin-left: 15%;width: 60%;">
      <el-row v-for="(img, i) in imgList" :key="i" style="width: 100%;">
        <el-row style="margin-top: 20px;margin-bottom: 16px;width: 100%;">
          <el-image :src="img" style="width: 100%;"></el-image>
        </el-row>
      </el-row>
    </div>
  </introduce-page>
</template>

<script>
import IntroducePage from './IntroducePage'
export default {
  name: 'CompanyCulture',
  components: { IntroducePage },
  data() {
    return {
      imgList: [require('../../assets/img/introduce/culture1.png'), require('../../assets/img/introduce/culture2.png'), require('../../assets/img/introduce/culture3.png')]
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/introduce/CompanyCulture.vue